/**
 * Popup type and configuration definitions
 */

/**
 * Types of popup windows supported
 */
export enum PopupType {
  Report = 'report',
  Events = 'events',
  Atons = 'atons',
  Help = 'help',
  Targets = 'targets',
  Routes = 'routes',
  VesselTimeline = 'vessel-timeline',
}

/**
 * Configuration for popup windows
 */
export interface PopupConfig {
  width: number;
  height: number;
  features?: string;
}

/**
 * Default configurations for each popup type
 */
export const POPUP_CONFIGS: Record<PopupType, PopupConfig> = {
  [PopupType.Report]: { width: 1200, height: 800 },
  [PopupType.Events]: { width: 1200, height: 800 },
  [PopupType.Atons]: { width: 1200, height: 800 },
  [PopupType.Help]: { width: 1100, height: 800 },
  [PopupType.Targets]: { width: 1400, height: 800 },
  [PopupType.Routes]: { width: 1400, height: 800 },
  [PopupType.VesselTimeline]: { width: 1400, height: 900 },
};
